import React, { Component, Fragment } from "react";
import Navbar from "components/header/navbar";
import Sidebar from "components/sidebar/sidebar";
import SubNavbarWrapper from "components/header/subNavbarWrapper";
import Footer from "components/footers/footer";
import ContentWrapper from "components/body/contentWrapper";
import { ContentNonSekretariat } from "./content";
import SubNavbar from "./subNavbar";

export default class DetailSuratNonSekretariat extends Component {
  render() {
    return (
      <Fragment>
        <div className="background-dark"></div>
        <Navbar />
        <Sidebar />
        <SubNavbarWrapper>
          <SubNavbar />
        </SubNavbarWrapper>
        <ContentWrapper>
          <ContentNonSekretariat />
        </ContentWrapper>
        <Footer />
      </Fragment>
    );
  }
}
